((w,d,l) => {

  // spテンプレート判定
  const is_mobile = () => ( d.querySelectorAll('#hybsMob').length != 0 )

  const replace_tomikura_head = html => $( is_mobile()? 'h2.moduletitle' : '.mainImg .mainImgInner').replaceWith( html )

  const init = the_id => {
    // tomikuraだったらmainImgInnerを差し替える
    if( the_id === 12 ) $.get('/asset/html/tomikura-head.html').then( replace_tomikura_head )
  }

  $(() => {
    const the_id = d.body.getAttribute('class').replace(/^(.+)?is--article-([\d]+)(.+)?$/,'$2')
    init( parseInt( the_id ) )
  })

})( window, document, location );